"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Model = void 0;
var react3l_decorators_1 = require("react3l-decorators");
/**
 * @package [react3l-common](https://www.npmjs.com/package/react3l-common)
 * @description Auto mapper model
 */
var Model = /** @class */ (function () {
    function Model() {
    }
    /**
     * Create an instance of this class with its prototype
     */
    Model.create = function () {
        return Object.create(this.prototype);
    };
    /**
     * Used for circular relationship only.
     *
     * @param Parent
     * @param Child
     * @param field
     */
    Model.hasMany = function (Parent, Child, field) {
        react3l_decorators_1.ObjectList(Child)(Parent.prototype, field);
    };
    /**
     * Used for circular relationship only.
     *
     * @param Child
     * @param Parent
     * @param field
     */
    Model.belongsTo = function (Child, Parent, field) {
        react3l_decorators_1.ObjectField(Parent)(Child.prototype, field);
    };
    /**
     * Serialize this model to JSON string
     *
     * @return {string}
     */
    Model.prototype.toString = function () {
        return JSON.stringify(this);
    };
    return Model;
}());
exports.Model = Model;
//# sourceMappingURL=Model.js.map